import $ from 'jquery';

if( $( '.news-page' ).length ){
  let newsCard = document.querySelectorAll( '.news-card' );
  let newsCategory = document.querySelectorAll( '.news-radio[name="news-cat"]' )
  let loadMore = document.querySelector( '.load-more' )

  $( newsCategory ).on( 'change', function() {
    let selectedID = $( this ).attr( 'id' )
    if( selectedID == 'view-all' ) {
      $( newsCard ).addClass( 'hide' )
      $( newsCard ).slice( 0, 9 ).removeClass( 'hide' );
      $( '.news-card.hide' ).length ? $( loadMore ).removeClass( 'hide' ) : $( loadMore ).addClass( 'hide' )
    } else {
      $( newsCard ).addClass( 'hide' )
      $( `.news-card[data-cat='${selectedID}']` ).slice( 0, 9 ).removeClass( 'hide' );
      $( `.news-card.hide[data-cat='${selectedID}']` ).length ? $( loadMore ).removeClass( 'hide' ) : $( loadMore ).addClass( 'hide' )
    }
  } )

  $( loadMore ).on( 'click', ( e ) => {
    e.preventDefault();
    let checkedValue = $( '.news-radio[name="news-cat"]:checked' ).val()
    
    if( checkedValue == 'view-all' ) {
      $( '.news-card.hide' ).slice( 0, 9 ).removeClass( 'hide' );
      $( '.news-card.hide' ).length ? $( loadMore ).removeClass( 'hide' ) : $( loadMore ).addClass( 'hide' )
    } else {
      $( `.news-card.hide[data-cat='${checkedValue}']` ).slice( 0, 9 ).removeClass( 'hide' );
      $( `.news-card.hide[data-cat='${checkedValue}']` ).length ? $( loadMore ).removeClass( 'hide' ) : $( loadMore ).addClass( 'hide' )
    }

  })
}